<div class="p-15px">
  <div>Add a new fee recipient for {{ txnType }} transactions</div>
  <div>
    <search-bar
      [showCloutavista]="false"
      [isSearchForUsersToSendDESO]="true"
      (creatorToMessage)="selectedCreator = $event"
    ></search-bar>
  </div>
  <div class="px-5px" *ngIf="selectedCreator">
    Fee Recipient:
    <simple-profile-card
      [profile]="selectedCreator"
      [singleColumn]="true"
      [hideFollowLink]="true"
    ></simple-profile-card>
  </div>
  <div class="input-group py-15px">
    <div class="input-group-prepend">
      <span class="input-group-text">Fee Amount Received (in $DESO)</span>
    </div>
    <input
      class="form-control"
      type="number"
      matInput
      [(ngModel)]="feeAmount"
    />
  </div>
  <button
    (click)="setTransactionFees()"
    class="btn btn-outline-primary fs-15px"
    [disabled]="
      feeAmount <= 0 ||
      !selectedCreator?.PublicKeyBase58Check ||
      updatingTransactionFees
    "
  >
    Add Fee
  </button>
  <div *ngIf="transactionFeeMap[txnType]?.length" class="py-15px">
    <div>Existing Fee Recipients for {{ txnType }} Transactions</div>
    <div
      *ngFor="let transactionFee of transactionFeeMap[txnType]"
      class="d-flex flex-start align-items-center"
    >
      <simple-profile-card
        [profile]="
          transactionFee.ProfileEntryResponse || {
            PublicKeyBase58Check: transactionFee.PublicKeyBase58Check
          }
        "
        [hideFollowLink]="true"
        [singleColumn]="true"
      ></simple-profile-card>
      <span>
        {{ globalVars.nanosToDeSo(transactionFee.AmountNanos) }} $DESO
      </span>
    </div>
  </div>
</div>
